import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Car } from 'lucide-react';
import './Css/CarActionModal.css'; // You'll create this file for custom styling

export default function CarActionModalPopup({ isOpen, onClose, onAction }) {
  const handleAction = (action) => {
    console.log(`Selected action: ${action}`);
    if (onAction) {
      onAction(action);
    }
    onClose(); // Close the modal
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered className="car-action-modal">
      <Modal.Header closeButton>
        <Modal.Title>Car Drop Off</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <p className="car-action-instruction">Please select an action for your vehicle:</p>
        
        <div className="car-action-buttons">
          {/* Switch Car Button */}
          <button 
            onClick={() => handleAction('switch')}
            className="car-action-btn car-action-switch"
          >
            <div className="action-content">
              <div className="icon-wrapper blue">
                <Car size={20} />
              </div>
              <span className="action-text">Switch Car</span>
            </div>
            <span className="arrow-icon">›</span>
          </button>
          
          {/* Repo Car Button */}
          <button 
            onClick={() => handleAction('repo')}
            className="car-action-btn car-action-repo"
          >
            <div className="action-content">
              <div className="icon-wrapper yellow">
                <Car size={20} />
              </div>
              <span className="action-text">Repo Car</span>
            </div>
            <span className="arrow-icon">›</span>
          </button>
          
          {/* Drop Car Button */}
          <button 
            onClick={() => handleAction('drop')}
            className="car-action-btn car-action-drop"
          >
            <div className="action-content">
              <div className="icon-wrapper red">
                <Car size={20} />
              </div>
              <span className="action-text">Drop Car</span>
            </div>
            <span className="arrow-icon">›</span>
          </button>
        </div>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}